//garde en mémoire les forms pour le nouveau Lot et Fournisseur

import * as intchaine from "./interface-chaine";
import * as intbd from "./interface-bd";
import { memo } from "react";
import { DEBUG } from "./utilitaires";

// export var addressIPRemote = "localhost"
// export var addressIPRemote = "44.202.104.50", 18.212.6.99

export var addressIPRemote = "tracefournisseurs.eu";
export var addressIPRemotebd = "tracebd.eu";
export var addressIPRemoteimages = "traceimages.eu";

//export var addressIPRemote = "localhost";
// export var addressIPRemotebd = "localhost";
//export var addressIPRemoteimages = "localhost";


//NOUVEAU LOT
//le nouveau Lot
export var lotEnMemoire = {
  image: "",
  note: 0,
  classement: 0,
  categorie: 1,
  carbone: "",
  carboneTot: 0,
  carbonePert: true,
  DLC: "",
  couleur: "black",
};

export var lesSousLotsEnMemoire = [];

export async function chargerLot (numLot) {
  if (DEBUG) console.log("chargement du lot ", numLot);
  var infosLot = await intchaine.getInfosLot(numLot);
  var {
    0: typeLot,
    1: nomLot,
    2: libelle,
    3: hashIm,
    4: descrL,
    5: argum,
    6: lotsFi,
    7: pourcentL,
    8: lotsP,
    9: idF,
    10: dateL,
    11: noteL,
    12: classementL,
    13: fabL,
    14: catL,
    15: paysL,
    16: pourcentExt,
    17: carbone,
    18: carboneTot,
    19: carbonePert,
    20: carboneRaj,
    21: DLC,
    22: rappel
  } = infosLot;  
  if (DEBUG) console.log("infosLot = ", infosLot);
  //lotsFi = lotsFi.map((item) => parseInt(item, 10));
  // pourcentL = pourcentL.map((item) => parseInt(item, 10));
  // carboneRaj = carboneRaj.map((item) => parseInt(item, 10));
  if (DEBUG) console.log("lotFi dans chargerLot: ", lotsFi);
  if (DEBUG) console.log("pourcentL dans chargerLot: ", pourcentL);
  lotEnMemoire = {
    image: "",
    note: 0,
    classement: 0,
    categorie: 1,
    carbone: "",
    carboneTot: 0,
    carbonePert: true,
    DLC: "",
    couleur: "black",
  };
  lesSousLotsEnMemoire = [];

  lotEnMemoire["numFournisseur"] = nomLot;
  lotEnMemoire["libelle"] = libelle;
  lotEnMemoire["image"] = hashIm;
  lotEnMemoire["descr"] = descrL;
  lotEnMemoire["arg"] = argum;
  lotEnMemoire["pourcentExt"] = formatterPourcent(pourcentExt);
  lotEnMemoire["carbone"] = carbone;
  lotEnMemoire["DLC"] = DLC;

  if (DEBUG) console.log("lotEnMemoire = ", lotEnMemoire);

  for (var i = 0; i < lotsFi.length; i++) {
    let infosSousLot = await intchaine.getInfosLot(lotsFi[i]);
    let {
      0: typeLot,
      1: nomLot,
      2: libelle,
      3: hashIm,
      4: descrL,
      5: argum,
      6: lotsFibidon,
      7: pourcentLbidon,
      8: lotsP,
      9: idF,
      10: dateL,
      11: noteL,
      12: classementL,
      13: fabL,
      14: catL,
      15: paysL,
      16: pourcentExt,
      17: carbone,
      18: carboneTot,
      19: carbonePert,
      20: carboneRajbidon,
      21: DLC,
      22: rappel
    } = infosSousLot;  
 
    lesSousLotsEnMemoire.push({ ident: i+1 }); 

    lesSousLotsEnMemoire[i]["type"] = typeLot;    

    lesSousLotsEnMemoire[i]["numTraceur"] = lotsFi[i];  
    lesSousLotsEnMemoire[i]["numFournisseur"] = nomLot;      
    lesSousLotsEnMemoire[i]["nomFabricant"] = fabL; 
    lesSousLotsEnMemoire[i]["paysFabricant"] = paysL; 
    lesSousLotsEnMemoire[i]["libelle"] = libelle; 
    lesSousLotsEnMemoire[i]["descr"] = descrL;
    lesSousLotsEnMemoire[i]["pourcent"] = formatterPourcent(pourcentL[i]);
    lesSousLotsEnMemoire[i]["carbone"] = carbone;
    lesSousLotsEnMemoire[i]["carboneRaj"] = carboneRaj[i]; 
    lesSousLotsEnMemoire[i]["DLC"] = DLC;
    lesSousLotsEnMemoire[i]["couleur"] = "black";
  }
  if (DEBUG) console.log("dans recopier,chargerLot, les sous lots = ", lesSousLotsEnMemoire);
}

function formatterPourcent(p) {
  let st = p.toString();
  if (st.length == 4) {
    return st;
  } else if (st.length == 3) {
    return "0" + st;
  } else if (st.length == 2) {
    return"00" + st;
  } else if (st.length == 1) {
    return"000" + st;
  }
}

export function resetLotEnMemoire() {
  lotEnMemoire = {};
}

export function changerChampLot(champ, value) {
  lotEnMemoire[champ] = value;
  //   console.log("dans changer champ index=",index,"valeur ecrite=", lesSousLotsEnMemoire[index][champ])
}

export async function calculerNoteEtClassement() {
  lotEnMemoire["note"] = await simulerNote();
  lotEnMemoire["classement"] = await simulerClassement(
    lotEnMemoire["note"],
    lotEnMemoire["categorie"]
  );
}

export async function simulerNote() {
  if (DEBUG) console.log("je calcule la note");
  var somme = 0,
    somme1 = 0,
    somme2 = 0,
    somme3 = 0,
    coeff1 = 40,
    coeff2 = 40,
    coeff3 = 20;
  if (parseInt(lotEnMemoire["pourcentExt"], 10) == 0) {
    somme1 = 10000;
    somme2 = 10000 * 10000;
    somme3 = 10000 * 10000 * 10000;
  } else {
    somme1 += 10000 - parseInt(lotEnMemoire["pourcentExt"], 10);
    var denom1 = parseInt(lotEnMemoire["pourcentExt"], 10);
  }
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    somme1 += parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10);
    if (lesSousLotsEnMemoire[i]["type"] == "traceur") {
      let numlotfils1 = parseInt(lesSousLotsEnMemoire[i]["numTraceur"], 10);
      let infosLot1 = await intchaine.getInfosLot(numlotfils1);
      let lotsFi1 = infosLot1[6];
      let pourcents1 = infosLot1[7];
      let pourcentExt1 = infosLot1[16];
      if (parseInt(pourcentExt1, 10) == 0) {
        somme2 +=
          10000 *
          ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
            denom1);
        somme3 +=
          10000 *
          10000 *
          ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
            denom1);
      } else {
        somme2 +=
          (10000 - parseInt(pourcentExt1, 10)) *
          ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
            denom1);
      }
      lotsFi1 = lotsFi1.map((item) => parseInt(item, 10));
      let pourcents1abs = pourcents1.map((item) => parseInt(item, 10));
      let pourcents1prop = pourcents1.map(
        (item) => (parseInt(item, 10) * 10000) / parseInt(pourcentExt1, 10)
      );
      for (let j = 0; j < lotsFi1.length; j++) {
        somme2 +=
          pourcents1abs[j] *
          ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
            denom1);
        let numlotfils2 = lotsFi1[j];
        let infosLot2 = await intchaine.getInfosLot(numlotfils2);
        let lotsFi2 = infosLot2[6];
        let pourcents2 = infosLot2[7];
        let pourcentExt2 = infosLot2[16];
        let typelot = infosLot2[0];
        if (typelot == "traceur") {
          if (parseInt(pourcentExt2, 10) == 0) {
            somme3 +=
              10000 *
              ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
                denom1) *
              pourcents1prop[j];
          } else {
            somme3 +=
              (10000 - parseInt(pourcentExt2, 10)) *
              ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
                denom1) *
              pourcents1prop[j];
          }
        }
        lotsFi2 = lotsFi2.map((item) => parseInt(item, 10));
        let pourcents2abs = pourcents2.map((item) => parseInt(item, 10));
        let pourcents2prop = pourcents2.map(
          (item) => (parseInt(item, 10) * 10000) / parseInt(pourcentExt2, 10)
        );
        for (let k = 0; k < lotsFi2.length; k++) {
          somme3 +=
            pourcents2abs[k] *
            ((10000 * parseInt(lesSousLotsEnMemoire[i]["pourcent"], 10)) /
              denom1) *
            pourcents1prop[j];
        }
      }
    }
  }
  // if (DEBUG) console.log("les sommes:");
  somme1 = (coeff1 * somme1) / 100;
  // if (DEBUG) console.log("somme1=", somme1);
  somme2 = (coeff2 * somme2) / (100 * 10000);
  // if (DEBUG) console.log("somme2=", somme2);
  somme3 = (coeff3 * somme3) / (100 * 10000 * 10000);
  // if (DEBUG) console.log("somme3=", somme3);
  somme = somme1 + somme2 + somme3;
  // if (DEBUG) console.log("somme totale real =", somme);
  // if (DEBUG) console.log("somme totale floor =", Math.floor(somme));
  return Math.min(Math.floor(somme), 9999);
}

export async function simulerClassement(note, categorie) {
  return await intchaine.simulerClassement(note, categorie);
}

export function getChampLot(champ) {
  if (lotEnMemoire[champ]) {
    return lotEnMemoire[champ];
  } else {
    return "";
  }
}

//les sous lots
//export var lesSousLotsEnMemoire = [];

export function resetLesSousLotsEnMemoire() {
  lesSousLotsEnMemoire = [];
}

export function annulerTousSousLotsEnMemoire() {
  lesSousLotsEnMemoire = [];
}

function existeSousLotEnMemoire(num) {
  let res = lesSousLotsEnMemoire.filter((item) => item.ident === num);
  //   console.log("res dans existe: ", res)
  return res.length > 0;
}

function trouverIndex(id) {
  for (var i = 0; i < lesSousLotsEnMemoire.length; i++) {
    if (lesSousLotsEnMemoire[i].ident === id) {
      return i;
    }
  }
  if (DEBUG) console.log("erreur dans trouverIndex!!");
  return -1;
}

export function changerChampSousLot(id, champ, value) {
  let index = trouverIndex(id);
  lesSousLotsEnMemoire[index][champ] = value;
  if (DEBUG) console.log("dans changer champ index=",index,"valeur ecrite=", lesSousLotsEnMemoire[index][champ])
}

// export function rajouterSousLot(num) {
//   lesSousLotsEnMemoire.push({ ident: num });
// }

export function enleverSousLot(id) {
  lesSousLotsEnMemoire = lesSousLotsEnMemoire.filter(
    (item) => item.ident !== id
  );
  if (DEBUG)
    console.log(
      "dans recopie, j'ai enlevé un sous lot, donc length = ",
      lesSousLotsEnMemoire.length
    );
}

export function checkSiExisteSousLot(id, type) {
  if (!existeSousLotEnMemoire(id)) {
    if (type === "traceur") {
      lesSousLotsEnMemoire.push({
        ident: id,
        type: "traceur",
        carbone: "",   //modifié à 0, c'était ""
        carboneTot: 0,  
        carboneRaj: "",   //modifié à 0, c'était ""
        carbonePert: true,
        DLC: "",
        couleur: "black",
      });
    } else if (type === "fournisseur") {
      lesSousLotsEnMemoire.push({
        ident: id,
        type: "fournisseur",
        carbone: "",  //modifié à 0, c'était ""
        carboneRaj: "",  //modifié à 0, c'était ""
        carbonePert: true,
        DLC: "",
        couleur: "black",
      });
    } else {
      if (DEBUG) console.log("type de sous-lot inconnu dans checksiexiste!");
    }
    if (DEBUG)
      console.log(
        "dans recopie, j'ai rajouté un sous lot, donc length = ",
        lesSousLotsEnMemoire.length
      );
  } else {
    let index = trouverIndex(id);
    lesSousLotsEnMemoire[index]["carbonePert"] = true;
  }
}

export function getChampSousLot(id, champ) {
  let index = trouverIndex(id);
  if (lesSousLotsEnMemoire[index][champ]) {
    return lesSousLotsEnMemoire[index][champ];
  } else {
    return "";
  }
}

export function afficherLengthSousLots() {
  if (DEBUG) console.log("dans afficher: ", lesSousLotsEnMemoire.length);
}

function testerNombre(nbre) {
  let nbrecorrect = /^[0-9]+$/i;
  let res = nbrecorrect.test(nbre);
  if (DEBUG) console.log("dans recopier testernbre: ", nbre, "resultat: ", res);
  return res;
}

function testerPourcentage(pour) {
  let nbrecorrect = /^[0-9]{4,4}$/i;
  let res = nbrecorrect.test(pour);
  if (DEBUG) console.log("dans recopier tester pourcentage: ", pour, "resultat: ", res);
  return res;
}

export function testerLotTraceur(numLstring) {
  // en fait on ne fait que tester que c'est un nombre...voir fonction suivante
  if (!(testerNombre(numLstring.trim()))) {
    return false;
  }
  return true;
}

export function lotsDistincts() {
  let liste = [];
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    if (lesSousLotsEnMemoire[i]["type"] == "traceur") {
      if (liste.includes(lesSousLotsEnMemoire[i]["numTraceur"])) {
        if (DEBUG) console.log("Dans lotsDistincts, un lot dupliqué ", lesSousLotsEnMemoire[i]["numTraceur"]);
        return false;
      } else {
        liste.push(lesSousLotsEnMemoire[i]["numTraceur"]);
      }
    }
  }
  if (DEBUG) console.log("Dans lotsDistincts, Pas de lots dupliqués");
  return true;
}


export async function listeLotsNonTraceurs() {
  let liste = [];
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    if (lesSousLotsEnMemoire[i]["type"] == "traceur") {
      let numL = parseInt(lesSousLotsEnMemoire[i]["numTraceur"], 10);
      // if (DEBUG) console.log("DANS LISTE LOTS NON TRACEURS, numL est: ", numL);
      let res = await intchaine.typeLot(numL);
      if (res !== "traceur") {
        liste.push(lesSousLotsEnMemoire[i]["numTraceur"]);
      }
    }
  }
  if (DEBUG) console.log("LISTE LOTS NON TRACEURS: ", liste)
  return liste;
}

export function validerSousLots() {
  if (DEBUG)
    console.log(
      "j'execute validerSousLots avec nb de sous-lots de ",
      lesSousLotsEnMemoire.length
    );
  if (DEBUG) console.log("dans recopie, les SOUS LOTS SONT: ", lesSousLotsEnMemoire );
  if (lesSousLotsEnMemoire.length === 0) {
    return true;
  }
  let correct = true;
  for (var i = 0; i < lesSousLotsEnMemoire.length; i++) {
    // let sLot = lesSousLotsEnMemoire[i]
    lesSousLotsEnMemoire[i]["couleur"] = "black";
    if (lesSousLotsEnMemoire[i]["type"] == "traceur") {
      if (DEBUG) console.log("dans recopie, NUM TRACEUR  est: ", lesSousLotsEnMemoire[i]["numTraceur"] );
      // console.log("PAS 1");
      if (!lesSousLotsEnMemoire[i]["numTraceur"]) {       
        if (DEBUG) console.log("FAUX 1 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;
        continue;
        //return false;
      }
      // console.log("PAS 2");
      // console.log("sans trim ", (lesSousLotsEnMemoire[i]["numTraceur"]));
      // console.log("le trim et tester nombre", (testerNombre((lesSousLotsEnMemoire[i]["numTraceur"]).trim())));
      // console.log("PAS 2.5");
      if (!(testerNombre((lesSousLotsEnMemoire[i]["numTraceur"]).trim()))) {
        if (DEBUG) console.log("TESTERNOMBRE de num de sous lot traceur: ",testerNombre(lesSousLotsEnMemoire[i]["numTraceur"]))
        if (DEBUG) console.log("FAUX 2 "); 
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;   
        //return false;
      }
      // console.log("PAS 3");
      if (DEBUG) console.log("je vais executer numvaltraceur");
      let numvaltraceur = parseInt(lesSousLotsEnMemoire[i]["numTraceur"], 10);
      if (DEBUG) console.log("numvaltraceur = ", numvaltraceur);
      if (numvaltraceur <= 0) {
        if (DEBUG) console.log("FAUX 3 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;     
        continue;  
        //return false;
      }
      // let numSousLot = parseInt(sLot["numTraceur"],10)
      // let existeSurChaine = await existeSousLotSurChaine(numSousLot) //ici verifier que le lot existe sur la block
      // console.log("PAS 4");
      if (DEBUG) console.log("NUMVALTRACEUR = ", numvaltraceur)
      let existeSurChaine = testerLotTraceur(
         lesSousLotsEnMemoire[i]["numTraceur"]
      );
      // console.log("PAS 5");
      if (DEBUG) console.log("EXISTESURCHAINE = ", existeSurChaine);
      if (!existeSurChaine) {
        if (DEBUG) console.log("CE LOT N EXISTE PAS");
        if (DEBUG) console.log("FAUX 3 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;      
        continue;
        //return false;
      }
      if (!(lesSousLotsEnMemoire[i]["pourcent"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;    
        continue;       
        //return false
      }; 
      if (!(testerPourcentage((lesSousLotsEnMemoire[i]["pourcent"]).trim()))) {
        if (DEBUG) console.log("FAUX 4 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if (lesSousLotsEnMemoire[i]["carboneRaj"].trim() !== '' &&  !(testerNombre((lesSousLotsEnMemoire[i]["carboneRaj"]).trim()))) {
        if (DEBUG) console.log("FAUX 5, CARBONE RAJ EST:  ", lesSousLotsEnMemoire[i]["carboneRaj"]);
        if (DEBUG) console.log("FAUX 5, VOICI TRIM:  ", lesSousLotsEnMemoire[i]["carboneRaj"].trim() !== '');
        if (DEBUG) console.log("FAUX 5, VOICI PARSEINT:  ", !(parseInt(lesSousLotsEnMemoire[i]["carboneRaj"],10) >=0) );
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }     
    }
    if (lesSousLotsEnMemoire[i]["type"] == "fournisseur") {
      if (DEBUG) console.log("lot de type: ", lesSousLotsEnMemoire[i]["type"].trim())
      if (DEBUG) console.log("numFournisseur: ", lesSousLotsEnMemoire[i]["numFournisseur"])
      if (!(lesSousLotsEnMemoire[i]["numFournisseur"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false
      };
      if (!(lesSousLotsEnMemoire[i]["numFournisseur"].trim())) {
        if (DEBUG) console.log("Ffournisseur FAUX 1 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if (!(lesSousLotsEnMemoire[i]["nomFabricant"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false
      };
      if (!(lesSousLotsEnMemoire[i]["nomFabricant"].trim())) {
        if (DEBUG) console.log("Ffournisseur FAUX 2 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;  
        continue; 
        //return false;
      }
      if (!(lesSousLotsEnMemoire[i]["paysFabricant"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;  
        continue; 
        //return false
      };
      if (!(lesSousLotsEnMemoire[i]["paysFabricant"].trim())) {
        if (DEBUG) console.log("Ffournisseur FAUX 3 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if (!(lesSousLotsEnMemoire[i]["libelle"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false
      };
      if (!(lesSousLotsEnMemoire[i]["libelle"].trim())) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if (!(lesSousLotsEnMemoire[i]["descr"])) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false
      };
      if (!(lesSousLotsEnMemoire[i]["descr"].trim())) {
        if (DEBUG) console.log("Ffournisseur FAUX 4 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if (!(testerPourcentage(lesSousLotsEnMemoire[i]["pourcent"]))) {
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false
      };
      if (!(testerPourcentage((lesSousLotsEnMemoire[i]["pourcent"]).trim()))) {
        if (DEBUG) console.log("Ffournisseur FAUX 5 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if ((lesSousLotsEnMemoire[i]["carboneRaj"]).trim() !== '' &&   !(testerNombre((lesSousLotsEnMemoire[i]["carboneRaj"]).trim()))) {
        // if (DEBUG) console.log("sous lot carbone raj: ",lesSousLotsEnMemoire[i]["carboneRaj"] );
        if (DEBUG) console.log("Ffournisseur FAUX 6 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }
      if ((lesSousLotsEnMemoire[i]["carbone"]).trim() !== '' &&   !(testerNombre((lesSousLotsEnMemoire[i]["carbone"]).trim()))) {
        // if (DEBUG) console.log("sous lot carbone: ",lesSousLotsEnMemoire[i]["carbone"] );
        if (DEBUG) console.log("Ffournisseur FAUX 7 ");
        lesSousLotsEnMemoire[i]["couleur"] = "red";
        correct = false;   
        continue;
        //return false;
      }                
    }
  }
  return correct;
}

function traduirePourcentage(pour) {
  let chiffres = Array.from(pour.trim());
  // if (DEBUG) console.log("traduirepour: ", pour, "les chiffres: ", chiffres);
  let res = 0;
  for (let i = 0; i < chiffres.length; i++) {
    res += (parseInt(chiffres[i], 10) * 1000) / 10 ** i;
  }
  // if (DEBUG) console.log("de traduirepourcent, res= ", res);
  return res;
}

export function verifierSommePourcentages() {
  // let somme = 0;
  let somme = 10000 - traduirePourcentage(lotEnMemoire["pourcentExt"]);
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    if (lesSousLotsEnMemoire[i]["pourcent"]) {
      // somme += parseInt(lesSousLotsEnMemoire[i]["pourcent"],10)
      somme += traduirePourcentage(lesSousLotsEnMemoire[i]["pourcent"]);
    }
  }
  return somme <= 10000; // pourcent est forcé sur 4 chiffres
}


export async function goCreerLot() {
  // lotEnMemoire["image"] = "image forcée"

  let nomL = lotEnMemoire["numFournisseur"];
  let libelle = lotEnMemoire["libelle"];
  let hashIm = lotEnMemoire["image"];
  let descrLot = lotEnMemoire["descr"];
  let argLot = lotEnMemoire["arg"];
  let nbreArt = lotEnMemoire["nbreArt"].trim();
  let pourcentExt = lotEnMemoire["pourcentExt"].trim();
  let catg = lotEnMemoire["categorie"];
  let nomFabrVide = ""; //pas de fabricant pour un lot traceur
  let catgneutre = 1;
  let paysFabrVide = "";
  let pourcentExtVide = 0;
  let carbone = lotEnMemoire["carbone"].trim();
  // if (carbone == '') carbone=0;

  let carboneTot = lotEnMemoire["carboneTot"];
  let carbonePert = lotEnMemoire["carbonePert"];
  let DLC = lotEnMemoire["DLC"].trim();

  var idF = await intchaine.getIdFournisseurParAdresse(
    intchaine.accountFournisseur
  );
  var note = lotEnMemoire["note"];
  var classement = lotEnMemoire["classement"];
  var lotsTraceurs = [];
  var pourcentsTraceurs = [];
  var numFourns = [];
  var nomFabs = [];
  var paysFabs = [];
  var libelleFourns = [];
  var descrFourns = [];
  var pourcentsFourn = [];
  var carboneF = [];
  var carbonePertF = [];
  var carboneRajT = [];
  var carboneRajF = [];

  if (carbone == '') {carbone=0; carbonePert=false;}

  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    var sousL = lesSousLotsEnMemoire[i];
    if (sousL["type"] == "traceur") {
      lotsTraceurs.push(sousL["numTraceur"]);
      pourcentsTraceurs.push(sousL["pourcent"].trim());
      let temp = sousL["carboneRaj"].trim();
      if (temp == '') temp = 0;
      carboneRajT.push(temp);
      // carboneRajT.push(sousL["carboneRaj"]);
    }
    if (sousL["type"] == "fournisseur") {
      numFourns.push(sousL["numFournisseur"]);
      nomFabs.push(sousL["nomFabricant"]);
      paysFabs.push(sousL["paysFabricant"]);
      libelleFourns.push(sousL["libelle"]);
      descrFourns.push(sousL["descr"]);
      pourcentsFourn.push(sousL["pourcent"].trim());
 
      let temp = sousL["carbone"].trim();
      if (temp == '') temp = 0;
      carboneF.push(temp);
      // carboneF.push(sousL["carbone"]); //verifier que c'est bon

      let tempbis = sousL["carboneRaj"].trim();
      if (tempbis == '') tempbis = 0;
      carboneRajF.push(tempbis);
      // carboneRajF.push(sousL["carboneRaj"]); //verifier que c'erst bon
      //if (!(parseInt(sousL["carbone"] >= 0)) || !(parseInt(sousL["carboneRaj"] >= 0))) sousL["carbonePert"] = false;
      carbonePertF.push(sousL["carbonePert"]); //verifier que c'est bon
    }
  }

  if (DEBUG) {
    console.log("Voici le lot que je vais creer sur la chaine");
    console.log("nomL:", nomL);
    console.log("libelle:", libelle);
    console.log("image: ", hashIm);
    console.log("descrLot:", descrLot);
    console.log("arglot:", argLot);
    console.log("nbreArt:", nbreArt);
    console.log("pourcentExt:", pourcentExt);
    console.log("catg:", catg);
    console.log("lots traceurs:", lotsTraceurs);
    console.log("pourcent:", pourcentsTraceurs);
    console.log("fournisseur:", idF);
    console.log("numfourn:", numFourns);
    console.log("libellefourn:", libelleFourns);
    console.log("nomFabs:", nomFabs);
    console.log("paysFabs:", paysFabs);
    console.log("descrfourn:", descrFourns);
    console.log("pourcentfourn:", pourcentsFourn);
    console.log("note:", note);
    console.log("classement:", classement);
    console.log("carbone:", carbone);
    console.log("carboneTot:", carboneTot);
    console.log("carbonePert:", carbonePert);
    console.log("carboneRajT:", carboneRajT);
    console.log("DLC:", DLC);
    console.log("carboneF:", carboneF);
    console.log("carboneRajF:", carboneRajF);
    console.log("carbonePertF:", carbonePertF);
  }

  // création du lot sur la chaîne
  if (DEBUG) console.log("je cree le lot sur la chaine");
  try {
    await intchaine.creerLotEtSousLots(
      nomL,
      libelle,
      hashIm,
      descrLot,
      argLot,
      lotsTraceurs,
      pourcentsTraceurs,
      idF,
      note,
      classement,
      catg,
      pourcentExt,
      carbone,
      carboneTot,
      carbonePert,
      carboneRajT,
      DLC,
      carboneF,
      carbonePertF,
      carboneRajF,
      numFourns,
      libelleFourns,
      nomFabs,
      paysFabs,
      descrFourns,
      pourcentsFourn
    );
  } catch (e) {
    if (DEBUG) console.log(e);
    if (DEBUG) console.log("erreur dans la ctéation du lot sur la chaine");
    throw e;
  }


  // dans la BD
  if (DEBUG) console.log("je cree le lot sur la BD");
  try {
    // var dernierLot = (await intchaine.getLengthLots()) - 1;
    var dernierLotF = await intchaine.getDernierLotFournisseur(idF);
    if (DEBUG)
      console.log(
        "de recopier, dernier lot fournisseur renvoyé par la blockchain: ",
        dernierLotF
      );
    // var idLdernier = dernierLot;
    await intbd.goCreerLotBD(
      dernierLotF,
      "traceur",
      nomL,
      libelle,
      hashIm,
      descrLot,
      argLot,
      nbreArt,
      idF,
      note,
      classement,
      nomFabrVide,
      catg,
      pourcentExt,
      paysFabrVide,
      carbone,
      carboneTot,
      carbonePert,
      DLC
    );
  } catch (e) {
    if (DEBUG) console.log(e);
    if (DEBUG) console.log("erreur dans la création du lot dans la BD");
  }

  // attraper la liste des lots fils pour les inscrire aussi dans la bd
  if (DEBUG) console.log("je cree les lots fils dans la bd");
  // var listeLotsFils = [164, 165, 480, 481];
  var listeLotsFils = await intchaine.getLotsFils(dernierLotF);
  if (DEBUG) console.log("dans creer lot, lot fils: ", listeLotsFils);
  var listePourcentFils = pourcentsTraceurs.concat(pourcentsFourn);
  var listeCarboneRajFils = carboneRajT.concat(carboneRajF);
  var nbreLotsTraceur = 0;
  var nbreLotsFournisseur = 0;
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    if (lesSousLotsEnMemoire[i]["type"] == "traceur") {
      nbreLotsTraceur++;
    }
  }
  nbreLotsFournisseur = lesSousLotsEnMemoire.length - nbreLotsTraceur;
  // dans lotsfils on trouve d'abord tous les lots traceur puis les lots fournisseurs
  // c'est pour ça qu'on les a comptés et qu'on part de ind = nbreLotsTraceur
  let ind = nbreLotsTraceur;
  for (let i = 0; i < lesSousLotsEnMemoire.length; i++) {
    let sousL = lesSousLotsEnMemoire[i];
    if (sousL["type"] == "fournisseur") {
      console.log(
        "je dois creer un nouveau lot fournisseur n° ",
        listeLotsFils[ind]
      );
      let idLotfils = listeLotsFils[ind];
      let typeL = "fournisseur";
      let nomL = sousL["numFournisseur"];
      let libelle = sousL["libelle"];
      let hashIm = "";
      let descrLot = sousL["descr"];
      let argLot = "";
      let nbart = 0;
      let idFourn = 0;
      let note = 0;
      let classement = 0;
      let nomFabr = sousL["nomFabricant"];
      let paysFabr = sousL["paysFabricant"];
      let carbone = sousL["carbone"];
      if (!carbone) carbone=0;
      let carboneTot = sousL["carboneTot"];
      if (!carboneTot) carboneTot=0;
      let carbonePert = sousL["carbonePert"];
      let DLC = "";

      try {
        await intbd.goCreerLotBD(
          idLotfils,
          typeL,
          nomL,
          libelle,
          hashIm,
          descrLot,
          argLot,
          nbart,
          idFourn,
          note,
          classement,
          nomFabr,
          catgneutre,
          pourcentExtVide, //pourcentage ingredients exterieurs, non significatif pour sous-lot fournisseur
          paysFabr,
          carbone,
          carboneTot,
          carbonePert,
          DLC
        );
      } catch (e) {
        if (DEBUG) console.log(e);
        if (DEBUG)
          console.log(
            "erreur dans la création d'un lot Fournisseur dans la BD"
          );
      }
      ind++;
    }
    if (DEBUG)
      console.log("nbreLotsFournisseur = ", nbreLotsFournisseur, "ind = ", ind);
  }

  // creer les relations lotpere lotfils dans la bd
  for (let i = 0; i < listeLotsFils.length; i++) {
    try {
      if (DEBUG)
        console.log(
          "creation pere fils:",
          dernierLotF,
          listeLotsFils[i],
          listePourcentFils[i],
          listeCarboneRajFils[i]
        );
      await intbd.goCreerLotPereLotFils(
        dernierLotF,
        listeLotsFils[i],
        listePourcentFils[i],
        listeCarboneRajFils[i]
      );
    } catch (e) {
      if (DEBUG) console.log(e);
      if (DEBUG)
        console.log("erreur dans la création d'un lot Pere Fils dans la BD");
    }
  }

  // creer les relations fournisseur lot dans la bd
  try {
    await intbd.goCreerFournisseurLot(idF, dernierLotF);
  } catch (e) {
    if (DEBUG) console.log(e);
    if (DEBUG)
      console.log("erreur dans la création de fournisseur x lot dans la BD");
  }
  if (DEBUG) console.log("j'ai executé creerLotsetsouslots chain et BD");
}

//FOURNISSEUR
export async function getDernierLotFournisseur(addrF) {
  let idF = await intchaine.getIdFournisseurParAdresse(addrF);
  return intchaine.getDernierLotFournisseur(idF);
}

export var fournisseurEnMemoire = {
  nomFournisseur: "",
  identFournisseur: "",
  adressePostale: "",
  pays: "",
};

export function changerChampFournisseur(champ, value) {
  fournisseurEnMemoire[champ] = value;
  //   console.log("dans changer champ index=",index,"valeur ecrite=", lesSousLotsEnMemoire[index][champ])
}

export function getChampFournisseur(champ) {
  if (fournisseurEnMemoire[champ]) {
    return fournisseurEnMemoire[champ];
  } else {
    return "";
  }
}

//champs fournisseur: "nomFournisseur"  "identFournisseur"  "adressePostale"  "pays"  "nomContact"  "adresseEmail"  "numTelephone"

export async function goCreerFournisseur() {
  let nomF = fournisseurEnMemoire["nomFournisseur"];
  let identF = fournisseurEnMemoire["identFournisseur"];
  let adresseP = fournisseurEnMemoire["adressePostale"];
  let paysF = fournisseurEnMemoire["pays"];
  let compteF = intchaine.accountFournisseur;
  let contactF = fournisseurEnMemoire["nomContact"];
  let adresseE = fournisseurEnMemoire["adresseEmail"];
  let numT = fournisseurEnMemoire["numTelephone"];

  try {
    await intchaine.creerFournisseur(nomF, identF, adresseP, paysF, compteF);
    var idF = await intchaine.getIdFournisseurParAdresse(compteF);
    if (DEBUG) console.log("idF renvoyé après la création du fournisseur sur la chaine: ", idF);
  } catch (e) {
    if (DEBUG) console.log(e);
    if (DEBUG)
      console.log("erreur dans la creation du fournisseur sur la chaine");
    throw e;
  }

  try {
    await intbd.goCreerFournisseurBD(
      idF,
      nomF,
      identF,
      adresseP,
      paysF,
      compteF,
      contactF,
      adresseE,
      numT
    );
  } catch (e) {
    if (DEBUG) console.log(e);
    if (DEBUG)
      console.log(
        "erreur dans l'appel à creer fournisseurs dans la BD pour le fournisseur n° ",
        idF
      );
    // throw e;
  }
}
